import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Folder20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.25C0.809643 1.25 0.25 1.80965 0.25 2.5V16.5C0.25 17.1904 0.809645 17.75 1.5 17.75H18.5C19.1904 17.75 19.75 17.1904 19.75 16.5V5.5C19.75 4.80964 19.1904 4.25 18.5 4.25H10.3107L7.67678 1.61612C7.44236 1.3817 7.12441 1.25 6.79289 1.25H1.5ZM1.75 4.25V2.75H6.68934L8.18934 4.25L1.75 4.25ZM1.75 5.75V16.25H18.25V5.75L1.75 5.75Z'
      fill='currentColor'
    />
  </Svg>
);

Folder20.displayName = 'Folder20';
export default Folder20;
